import {PrimaryButton} from '@/shared-components/Button'
import {PushStepType} from '@/types/NotificationStep'
import {useIntl} from 'react-intl'

interface Props {
  pushStep: PushStepType
}

export default function NotificationSubject({pushStep}: Props): React.JSX.Element {
  const {formatMessage} = useIntl()

  return (
    <div className="mt-2 rounded-lg border border-dashed border-border-dashed p-4">
      <div className="text-sm font-bold text-text-primary">{pushStep.subject}</div>
      <div className="pb-2 pt-2">
        <img src={pushStep.selectedImage?.url} />
      </div>
      <div className="mt-4 text-sm text-text-primary">{pushStep.message}</div>
      <div className="mt-4">
        <PrimaryButton
          size="large"
          data-cy="button-go-to-page"
          data-testid="button-go-to-page"
          onClick={() => {}}
          className="flex w-full justify-center"
        >
          {formatMessage({id: 'NOTIFICATION_DETAILS.GO_TO_PAGE_BUTTON'})}
        </PrimaryButton>
      </div>
    </div>
  )
}
